export default __webpack_public_path__ + "static/media/Versions - Comparisons_01.53afb0e1.jpg";